export default angular
  .module('doxy.global.common.services.checkOnline', [])
  .factory('checkOnline', function (notificationFactory) {
    function start() {
      window.addEventListener('online', () => {
        notificationFactory.showCommon('success', 'has-internet', 'connection');
      });

      window.addEventListener('offline', () => {
        notificationFactory.showCommon('error', 'no-internet', 'connection', 0); // no automatic hide for notification
      });
    }

    return { start };
  }).name;
